import { Navigate, useRoutes } from "react-router-dom";
import { Path, Slug } from "portal/utils/routing";
import { PlantProfileListPage } from "portal/views/plantProfiles/PlantProfileListPage";
import { PlantProfilePage } from "portal/views/plantProfiles/PlantProfilePage";
import { withPlantProfilesPageReadAccess } from "portal/views/plantProfiles/permissions";
import React, { FC } from "react";

const _PlantProfilesRoutes: FC = () => {
  return useRoutes([
    { path: "/", element: <PlantProfileListPage /> },
    {
      path: `/${Slug.ID}/${Slug.EDIT}?`,
      element: <PlantProfilePage />,
    },
  ]);
};

export const PlantProfilesRoutes = withPlantProfilesPageReadAccess(
  _PlantProfilesRoutes,
  <Navigate to={Path.FLEET} replace />
);
